import { Protocol } from '../Protocol';

export class ExperimentItemProtocol {
  public static readonly ALL_EXPERIMENT_ITEMS: string = `${Protocol.YATUNG_API_ROOT}/expt/item/all`;
}
